import { z } from 'zod'

export const ContactSchema = z.object({
	name: z
		.string({
			required_error: 'Enter the contact name.',
		})
		.min(1, 'Enter the contact name.'),
	email: z
		.string({
			required_error: 'Enter the contact email.',
		})
		.email('Enter a valid email address.'),
	phone: z.string().optional(),
	title: z.string().optional(),
})

export type ContactSchemaType = typeof ContactSchema

export type ContactValues = z.infer<typeof ContactSchema>

export function createEmptyContact(
	overrides: Partial<ContactValues> = {},
): ContactValues {
	return {
		name: '',
		email: '',
		phone: '',
		title: '',
		...overrides,
	}
}

export const ContactWithIdSchema = ContactSchema.extend({
	id: z
		.string({
			required_error: 'Missing contact id.',
		})
		.min(1, 'Missing contact id.'),
})

export type ContactWithIdValues = z.infer<typeof ContactWithIdSchema>

export function createEmptyContactWithId(
	overrides: Partial<ContactWithIdValues> = {},
): ContactWithIdValues {
	return {
		id: '',
		...createEmptyContact(),
		...overrides,
	}
}

export const RoleContactSchema = ContactSchema.extend({
	role: z
		.string({
			required_error: 'Enter the role or responsibility.',
		})
		.min(1, 'Enter the role or responsibility.'),
})

export type RoleContactSchemaType = typeof RoleContactSchema

export type RoleContactValues = z.infer<typeof RoleContactSchema>

export function createEmptyRoleContact(
	overrides: Partial<RoleContactValues> = {},
): RoleContactValues {
	return {
		...createEmptyContact(),
		role: '',
		...overrides,
	}
}
